<template>
  <div class="main-container">
    <div class="main-content-wrap">
      <div class="main-content-pannel flex flex-col main-content-pannel-t">
        <div class="flex flex-1">
          <div class="flex-1 main-content-left">
            <GmapMap :center="gmCenter" :zoom="gmZoom" style="flex: 1; height: 400px">
              <gmap-info-window
                :options="infoOptions"
                :position="infoWindowPos"
                :opened="infoWinOpen"
                @closeclick="infoWinOpen=false"
              >{{infoContent}}</gmap-info-window>
              <GmapMarker
                :key="index"
                v-for="(m, index) in gmMarkers"
                :position="m.position"
                :clickable="true"
                :draggable="false"
                @click="toggleInfoWindow(m, index)"
              />
            </GmapMap>
          </div>
          <div class="flex-1 main-content-right">
            <div class="main-pannel m-l-l m-r-l m-b-3l">
              <h3 class="main-pannel-header">
                Offices
                <ul class="main-pannel-header-menu">
                  <li>
                    <a
                      href="javascript:void(0)"
                      @click="addLocation()"
                      :class="{'active' : editOpen==1 }"
                    >
                      <i class="material-icons-outlined align-middle">add_location</i>Add Office
                    </a>
                  </li>
                </ul>
              </h3>
              <div class="main-pannel-content p-0">
                <div
                  class="flex office-wrap"
                  v-for="(location, index) in locations"
                  :key="index"
                  @click="editLocation(location)"
                >
                  <div class="office-icon">
                    <i class="material-icons-outlined align-middle">place</i>
                  </div>
                  <div class="flex-1">
                    <div class="office-name">{{location.name}}</div>
                    <div class="office-content flex">
                      <div class="flex-1 office-address">
                        <h3>Address</h3>
                        <p>{{location.address}}</p>
                      </div>
                      <div class="office-hours">
                        <h3>Hours Used</h3>
                        <p>
                          {{location.hoursUsed ? location.hoursUsed: "0"}}
                          <span>Hours</span>
                        </p>
                      </div>
                      <div class="office-user">
                        <h3>Consultants</h3>
                        <p>{{location.consultantCount? location.consultantCount : "0"}}</p>
                      </div>
                    </div>
                  </div>
                  <span class="office-close" @click.stop="deleteLocation(location)">
                    <i class="material-icons-outlined align-middle">close</i>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-1">
          <div class="main-pannel m-l-l m-r-l m-b-3l">
            <h3 class="main-pannel-header b-0">Account Shared Channels</h3>
            <div class="main-pannel-content p-0">
              <ag-grid-vue
                style="width: 100%; height: 300px;"
                class="ag-theme-material"
                :gridOptions="gridOptions"
                :columnDefs="channelColumnDefs"
                @column-resized="onColumnResized"
                :rowData="clientRowData"
              ></ag-grid-vue>
            </div>
          </div>
        </div>
      </div>
      <transition name="edit-pannel">
        <edit-pannel v-model="editOpen" title>
          <PanelLocation
            v-if="editOpen == 1"
            :id="editLocationId"
            :type="editLocationType"
            :name="editLocationName"
            :address="editLocationAddress"
            :submitLoading="locationSubmitLoading"
            @locationButtonClick="locationButtonClick"
          ></PanelLocation>
          <PanelLocation
            v-if="editOpen == 2"
            :id="editLocationId"
            :type="editLocationType"
            :name="editLocationName"
            :address="editLocationAddress"
            :submitLoading="locationSubmitLoading"
            @locationButtonClick="locationButtonClick"
          ></PanelLocation>
          <PanelClient
            v-if="editOpen == 3"
            :id="editClientId"
            :location="editClientLocation"
            :locations="editClientLocations"
            :firstName="editClientFirstName"
            :lastName="editClientLastName"
            :phoneNumber="editClientPhoneNumber"
            :submitLoading="clientSubmitLoading"
            @clientButtonClick="clientButtonClick"
          ></PanelClient>
        </edit-pannel>
      </transition>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import EditPannel from "@/components/EditPannel.vue";
import { db } from "@/vendor/firebase";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-enterprise";
import "@/assets/css/ag-grid.scss";
import { httpGet } from "@/http/http";
import * as utils from "@/utils/utils";
import PanelLocation from "@/components/client/clientInformation/PanelLocation.vue";
import PanelClient from "@/components/client/clientInformation/PanelClient.vue";
import GridActions from "@/components/client/clientInformation/GridActions.vue";

const GM_ZOOM = 8;
const GM_CENTER = { lat: 33.7750202, lng: -118.18609549999996 };

export default {
  data() {
    return {
      queryId: null,

      locations: null,
      clients: null,
      jobs: null,

      editOpen: false,

      editLocationId: null,
      editLocationType: null,
      editLocationName: null,
      editLocationAddress: null,

      editClientId: null,
      editClientLocation: null,
      editClientLocations: null,

      editClientFirstName: null,
      editClientLastName: null,
      editClientPhoneNumber: null,

      //   map
      gmZoom: GM_ZOOM,
      gmCenter: GM_CENTER,
      gmMarkers: [],
      infoContent: "",
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },

      gridOptions: {},
      channelColumnDefs: null,
      clientRowData: null,

      clientSubmitLoading: false,
      locationSubmitLoading: false
    };
  },
  computed: {
    ...mapState(["clientUserAccount"])
  },
  components: {
    EditPannel,
    AgGridVue,
    PanelLocation,
    PanelClient,
    GridActions
  },
  watch: {
    locations() {
      this.updateMap();
      this.updateClients();
      this.updateJobs();
    },
    clients() {
      this.updateClients();
      this.updateJobs();
    },
    jobs() {
      this.updateJobs();
    }
  },
  beforeMount() {
    this.queryId = this.$route.query.id;
    this.initColumnDefs();
    this.bindData();
  },
  methods: {
    bindData: function() {
      this.$bind(
        "locations",
        db.collection("locations").where("company", "==", this.queryId)
      );
      this.$bind(
        "clients",
        db.collection("clients").where("company", "==", this.queryId)
      );
      this.$bind(
        "jobs",
        db.collection("jobs").where("company", "==", this.queryId)
      );
    },
    initColumnDefs: function() {
      this.gridOptions = {
        defaultColDef: {
          sortable: true,
          resizable: true,
          filter: true,
          autoHeight: true
        },
        context: {
          componentParent: this
        },
        animateRows: true,
        enableCellTextSelection: true
      };
      this.channelColumnDefs = [
        { headerName: "USER NAME", field: "name" },
        { headerName: "PHONE NUMBER", field: "phoneNumber" },
        { headerName: "HOURS USED", field: "hoursUsed" },
        { headerName: "OFFICE", field: "office" },
        { headerName: "CHANNEL", field: "channelId" },
        {
          headerName: "ACTIONS",
          field: "id",
          width: 180,
          cellRendererFramework: "GridActions",
          sortable: false,
          filter: false,
          rowGroup: false
        }
      ];
    },
    onColumnResized(params) {
      params.api.resetRowHeights();
    },
    editLocation: function(location) {
      if (this.editOpen == 2 && this.editLocationId == location.id) {
        this.editOpen = false;
        return;
      }
      this.editLocationType = "edit";
      this.editLocationId = location.id;
      this.editLocationName = location.name;
      this.editLocationAddress = location.address;
      this.openEditPannel(2, false);
    },
    addLocation: function() {
      this.editLocationType = "add";
      this.editLocationId = this.editLocationName = this.editLocationAddress = null;
      this.openEditPannel(1, true);
    },
    openEditPannel: function(action, isToggle) {
      if (this.editOpen && this.editOpen != action) {
        this.editOpen = action;
        return;
      }
      if (isToggle) {
        this.editOpen = this.editOpen ? false : action;
      } else {
        this.editOpen = action;
      }
    },
    closeEditPannel: function() {
      this.editOpen = false;
    },
    locationButtonClick: function(id, name, address) {
      this.locationSubmitLoading = true;
      httpGet("save_company_location", {
        id,
        name,
        address,
        company: this.queryId
      })
        .then(response => {
          if (response.ok) {
            this.editOpen = false;
            this.$toasted.global.toast_success({ message: "save success" });
          } else {
            this.$toasted.global.toast_error({ message: "save error" });
          }
        })
        .finally(() => {
          this.locationSubmitLoading = false;
        });
    },
    deleteLocation: function(location) {
      utils.deleteConfirm(() => {
        db.collection("locations")
          .doc(location.id)
          .delete()
          .then(() => {
            this.$toasted.global.toast_success({ message: "delete success" });
          })
          .catch(() => {
            this.$toasted.global.toast_error({ message: "delete error" });
          });
      });
    },
    updateMap: function() {
      if (this.locations.length == 0) {
        this.gmZoom = GM_ZOOM;
        this.gmCenter = GM_CENTER;
        this.gmMarkers = [];
        this.infoWinOpen = false;
        return;
      }
      let maxLat, minLat, maxLng, minLng;
      this.gmMarkers = [];
      for (const index in this.locations) {
        if (this.locations[index].lat_lng) {
          maxLat =
            maxLat && maxLat > this.locations[index].lat_lng.lat
              ? maxLat
              : this.locations[index].lat_lng.lat;
          minLat =
            minLat && minLat < this.locations[index].lat_lng.lat
              ? minLat
              : this.locations[index].lat_lng.lat;
          maxLng =
            maxLng && maxLng > this.locations[index].lat_lng.lng
              ? maxLng
              : this.locations[index].lat_lng.lng;
          minLng =
            minLng && minLng < this.locations[index].lat_lng.lng
              ? minLng
              : this.locations[index].lat_lng.lng;
          this.gmMarkers.push({
            position: {
              lat: this.locations[index].lat_lng.lat,
              lng: this.locations[index].lat_lng.lng
            },
            infoText: this.locations[index].name
              ? this.locations[index].name
              : ""
          });
        }
      }
      this.gmCenter = {
        lat: (maxLat + minLat) / 2,
        lng: (maxLng + minLng) / 2
      };
      let zoomLevel;
      const maxDegree = Math.max(maxLat - minLat, maxLng - minLng);
      if (maxDegree >= 50) zoomLevel = 1;
      else if (maxDegree >= 10) zoomLevel = 3;
      else if (maxDegree >= 5) zoomLevel = 5;
      else if (maxDegree >= 3) zoomLevel = 6;
      else if (maxDegree >= 1) zoomLevel = 7;
      else if (maxDegree >= 0.5) zoomLevel = 8;
      else if (maxDegree >= 0.3) zoomLevel = 9;
      else zoomLevel = 10;
      this.gmZoom = zoomLevel;
      this.infoWinOpen = false;
    },
    toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      if (this.currentMidx == idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    editClient(data) {
      this.editClientId = data.id;
      this.editClientLocation = data.location;
      this.editClientFirstName = data.firstName;
      this.editClientLastName = data.lastName;
      this.editClientPhoneNumber = data.phoneNumber;
      this.editClientLocations = [];
      this.locations.forEach(item => {
        this.editClientLocations.push({ value: item.id, text: item.name });
      });
      this.openEditPannel(3, true);
    },
    clientButtonClick(uid, office, firstName, lastName, phoneNumber) {
      if (uid) {
        let parsedPhoneNumber = null;
        if (phoneNumber) {
          parsedPhoneNumber = utils.parsePhoneNumber(phoneNumber);
        }
        this.clientSubmitLoading = true;
        db.collection("clients")
          .doc(uid)
          .update({
            location: office,
            first_name: firstName,
            last_name: lastName,
            phone_number: parsedPhoneNumber
          })
          .then(() => {
            this.editOpen = false;
            this.$toasted.global.toast_success({ message: "save success" });
          })
          .catch(() => {
            this.editOpen = false;
            this.$toasted.global.toast_error({ message: "save error" });
          })
          .finally(() => {
            this.clientSubmitLoading = false;
          });
      } else {
        this.editOpen = false;
        this.$toasted.global.toast_error({ message: "save error" });
      }
    },
    updateClients() {
      this.clientRowData = [];
      this.clients.forEach((item, index) => {
        let office = "";
        for (const i in this.locations) {
          if (item.location == this.locations[i].id) {
            office = this.locations[i].name;
            break;
          }
        }
        this.clientRowData.push({
          channelId: item.channel_id,
          firstName: item.first_name ? item.first_name : "",
          lastName: item.last_name ? item.last_name : "",
          phoneNumber: item.phone_number ? item.phone_number : "",
          name:
            item.first_name && item.last_name
              ? item.first_name + " " + item.last_name
              : item.first_name
              ? item.first_name
              : item.last_name
              ? item.last_name
              : "",
          hoursUsed: "",
          location: item.location,
          office: office,
          id: item.id
        });
      });
    },
    updateJobs() {
      if (
        this.jobs &&
        this.jobs.length > 0 &&
        this.clientRowData &&
        Object.keys(this.clientRowData).length > 0
      ) {
        const channelToData = {};
        this.jobs.forEach(item => {
          if (
            item.channel_id &&
            item.check_in &&
            item.check_out &&
            item.consultant
          ) {
            const hours = utils.workHours(
              item.check_out - item.check_in,
              item.work_type
            );
            if (channelToData[item.channel_id]) {
              channelToData[item.channel_id].hours += hours;
              if (
                channelToData[item.channel_id].consultants.indexOf(
                  item.consultant
                ) < 0
              ) {
                channelToData[item.channel_id].consultants.push(
                  item.consultant
                );
              }
            } else
              channelToData[item.channel_id] = {
                hours,
                consultants: [item.consultant]
              };
          }
        });
        const locationToData = {};
        this.clientRowData.forEach(item => {
          if (channelToData[item.channelId]) {
            item.hoursUsed = channelToData[item.channelId].hours.toString();
            if (locationToData[item.location]) {
              locationToData[item.location].hours +=
                channelToData[item.channelId].hours;
              locationToData[item.location].consultants.concat(
                channelToData[item.channelId].consultants
              );
            } else {
              locationToData[item.location] = {
                hours: channelToData[item.channelId].hours
                  ? channelToData[item.channelId].hours
                  : 0,
                consultants: channelToData[item.channelId].consultants
                  ? channelToData[item.channelId].consultants
                  : []
              };
            }
          }
        });
        this.gridOptions.api.setRowData(this.clientRowData);
        if (this.locations && this.locations.length > 0) {
          this.locations.forEach(item => {
            this.$set(
              item,
              "hoursUsed",
              locationToData[item.id]
                ? locationToData[item.id].hours.toString()
                : 0
            );
            const consultants = locationToData[item.id]
              ? locationToData[item.id].consultants
              : [];
            const uniqueConsultants = consultants.filter((item, index) => {
              return consultants.indexOf(item) == index;
            });
            item.consultantCount = uniqueConsultants.length.toString();
            this.$set(
              item,
              "consultantCount",
              uniqueConsultants.length.toString()
            );
          });
        }
      }
    }
  }
};
</script>